import React, { Component } from 'react';
import { GoogleApiWrapper, Map, Marker } from 'google-maps-react';

class EventMap extends Component {
	constructor() {
		super();
		this.styles = [
			{
				featureType: 'all', elementType: 'all', stylers: []
			}
		];
		this.zoom = 1;
		this.dimensions = {
			width: 'auto', height: '398px'
		};
		this.initialCenter = {
			lat: 31.4826, lng: 0.0077
		};
	}

	getMarkers() {
		if ( this.props.events.length ) {
			return this.props.events.map( event => {
				if ( event.location_data.lat ) {
					return (<Marker
							key={ event.id }
							title={ event.title }
							name={ event.location_data.address }
							position={ this.getLatLng( event ) } />
					);
				}
			} );
		}
	}

	getLatLng( event ) {
		return {
			lat: event.location_data.lat, lng: event.location_data.lng
		};
	}

	render() {
		if ( 1 === this.props.events.length ) {
			this.zoom = 15;
			this.initialCenter = this.getLatLng( this.props.events[ 0 ] );
		}

		return (<div className="events-map">
				<Map google={ this.props.google }
				     scrollwheel={ false }
				     styles={ this.styles }
				     style={ this.dimensions }
				     clickableIcons={ false }
				     zoom={ this.zoom }
				     initialCenter={ this.initialCenter }
				     disableDefaultUI={ true }>
					{ this.getMarkers() }
				</Map>
			</div>
		);
	}
}

export default GoogleApiWrapper( {
	                                 apiKey    : (ISDA_Main.GMAPS_KEY
	                                 ), version: '3.28'
                                 } )( EventMap );